<template>
  <div class="huoban zindex11">
    <div class="left pc wow fadeInLeft">
      <div class="inner" ref="left">
        <ul>
          <li v-for="(item, index) in titles" :ref="'item' + index" :class="'active' + (index - activeIndex)" @click="leftFn(index, true)" :key="index">{{ item }}</li>
        </ul>
      </div>
    </div>
    <div class="left wap" ref="huobanleft">
      <ul>
        <li v-for="(item, index) in titles" :class="{ active: activeIndex === index }" @click="leftFn(index, true)" :key="index">{{ item }}</li>
      </ul>
    </div>
    <div class="right wow fadeInRight">
      <transition name="fade">
        <div v-if="isPc && allList && allList.length">
          <swiper ref="mySwiper" :options="swiperOptions" class="my-swiper pc pc-swiper">
            <swiper-slide v-for="(item, index) in allList" :key="index">
              <ul>
                <li v-for="(ite, ind) in item" :key="ind"><img class="logo" :src="ite.enterpriseLogoPc" alt=""></li>
              </ul>
            </swiper-slide>
          </swiper>
        </div>
      </transition>
      <swiper ref="mySwiperWap" :options="swiperOptionsWap" class="my-swiper wap" v-if="!isPc">
        <swiper-slide v-for="(item, index) in allList" :key="index">
          <ul>
            <li v-for="(ite, ind) in item" :key="ind"><img class="logo" :src="ite.enterpriseLogoPc" alt=""></li>
          </ul>
        </swiper-slide>
      </swiper>
      <div class="swiper-btns pc" v-if="allList.length > 1">
        <img src="https://static.worldaic.com.cn/2024/web/static/images/top.png" alt="" @click="prevTo('prev')" class="prev btn-img">
        <img src="https://static.worldaic.com.cn/2024/web/static/images/bottom.png" alt="" @click="prevTo('next')" class="next btn-img">
      </div>
      <div class="swiper-btns wap" v-if="allList.length > 1">
        <img src="https://static.worldaic.com.cn/2024/web/static/images/prev.png" alt="" @click="prevToWap('prev')" class="prev btn-img">
        <img src="https://static.worldaic.com.cn/2024/web/static/images/next.png" alt="" @click="prevToWap('next')" class="next btn-img">
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from "better-scroll";

export default {
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    }
  },
  name: 'huoban',
  data() {
    return {
      activeIndex: 0,
      titles: [],
      allList: [],
      swiperOptions: {
        direction : 'vertical',
      },
      swiperOptionsWap: {
        
      },
      timer: null
    }
  },
  mounted() {
      setInterval(x => {
        this.activeIndex ++
        if (this.activeIndex === this.titles.length) {
          this.activeIndex = 0
        }
        this.leftFn(this.activeIndex)
      }, 4000)
  },
  watch: {
    data: {
      handler(v) {
        if (v.length) {
          this.titles = v.map(x => x['title' + this.En])
          this.$nextTick(() => {
            this.init()
          })
        }
      }
    },
    En() {
      if (this.data && this.data.length) {
        this.titles = this.data.map(x => x['title' + this.En])
        this.$nextTick(() => {
          this.init()
        })
      }
    }
  },
  methods: {
    leftFn(index, isClick) {
      if (isClick) {
        this.$jsAPI('track','homeClick',
            {
              'floor_var': '合作伙伴',
              'position_var': index + 1 + '',
              'flowName_var': this.titles[index],
              'industryFirstCate_var': '无',
              'industrySecCate_var': '无',
              'tabName_var': '无',
            }
        );
        gio('track','homeClick',
            {
              'floor_var': '合作伙伴',
              'position_var': index + 1 + '',
              'flowName_var': this.titles[index],
              'industryCate_var': '无',
              'industryFirstCate_var': '无',
              'tabName_var': '无',
            }
        );
      }
      this.activeIndex = index
      this.scrollLeft.scrollToElement(this.$refs['item' + index][0])
      this.allList = []
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.setData()
      }, 200)
    },
    setData() {
      let arr = []
      for (let i = 0; i < Math.ceil(this.data[this.activeIndex].List.length / 15); i++) {
        arr.push([])
      }
      
      this.data[this.activeIndex].List.forEach((x, i) => {
        const ind = Math.floor(i / 15)
        arr[ind].push(x)
      })
      this.allList = arr
    },
    prevTo(str) {
      if (str === 'prev') {
        this.$refs.mySwiper.swiper.slidePrev()
      } else {
        this.$refs.mySwiper.swiper.slideNext()
      }
    },
    prevToWap(str) {
      if (str === 'prev') {
        this.$refs.mySwiperWap.swiper.slidePrev()
      } else {
        this.$refs.mySwiperWap.swiper.slideNext()
      }
    },
    init() {
      this.scrollLeft = new BScroll(this.$refs.left, {
        probeType: 3,
        click: true,
        mouseWheel: true
      })
      this.scroll = new BScroll(this.$refs.huobanleft, {
        click: true,
        mouseWheel: true,
        scrollX: true
      })
      this.$nextTick(() => {
        const height = this.$refs['item' + this.activeIndex][0].offsetHeight
        this.scrollLeft.on('scroll', (pos) => {
          this.activeIndex = Math.floor(Math.abs(pos.y / height))
          // this.leftFn(this.activeIndex)
          this.setData()
        })
      })
      
      this.leftFn(0)
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .huoban {
    position: relative;
    width: 100%;
    height: 4.62rem;
    background: url("https://static.worldaic.com.cn/2024/web/static/images/huoban-right.jpg");
    background-size: cover;
    padding-left: 5.48rem;
    padding-right: 1.96rem;

    .left {
      position: absolute;
      left: 0;
      top: 0;
      width: 4.2rem;
      height: 4.62rem;
      background: url("https://static.worldaic.com.cn/2024/web/static/images/huoban-left.jpg");
      background-size: cover;
      overflow: hidden;
      padding-top: 1.2rem;

      .inner {
        height: 3.42rem;
      }

      ul {
        padding: 1px 0 3rem 0.6rem;

        li {
          padding-top: .56rem;
          font-size: .24rem;
          font-weight: 500;
          color: #FFFFFF;
          line-height: .24rem;
          cursor: pointer;
          transition: 1s;
          box-sizing: content-box;

          // &:last-child {
          //   color: rgba(255, 255, 255, 0.6);
          // }

          &.active0 {
            font-size: .30rem;
            color: #FFFFFF;
            opacity: 1;
          }

          &.active1 {
            opacity: 1;
          }

          &.active2 {
            opacity: 1;
          }

          &.active3 {
            opacity: 0.6;
          }

          &.active4, &.active5, &.active6 {
            opacity: 0.6;
          }

          &.active-1 {
            opacity: 1;
          }

          &.active-2 {
            opacity: 0.6;
          }
        }
      }
    }

    .right {
      padding-top: .43rem;
      padding-bottom: .47rem;

      .logo {
        width: 2.32rem;
        height: 1.16rem;
        cursor: pointer;
      }

      .btn-img {
        position: absolute;
        cursor: pointer;
        right: 1.1rem;
        width: .44rem;
        margin: 0 .32rem;
      }

      ul {
        display: flex;
        flex-wrap: wrap;

        li {
          flex: 0 0 20%;
          height: 1.16rem;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .prev {
        top: .43rem;
      }

      .next {
        bottom: .47rem;
      }
    }
  }

  .pc-swiper {
    height: 3.48rem !important;
    overflow: hidden;

    /deep/.swiper-wrapper {
      flex-direction: column !important;
      height: 3.48rem !important;
    }
    /deep/ .swiper-slide {
      height: 3.48rem !important;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 1.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .huoban {
    position: relative;
    width: 100%;
    background: RGBA(228, 233, 232, 1);
    overflow: hidden;

    .left {
      width: 100%;
      height: 1.2rem;
      background: url("https://static.worldaic.com.cn/2024/web/static/images/huoban-top.png");
      background-size: 100% 100%;
      background-position: center center;

      ul {
        display: inline-block;
        white-space: nowrap;
        padding-left: .4rem;

        li {
          display: inline-block;
          font-size: .28rem;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 1.2rem;
          margin-right: .44rem;
          cursor: pointer;

          &.active {
            font-size: .32rem;
            color: #FFFFFF;
          }
        }
      }
    }

    .right {
      padding-top: .43rem;
      padding-bottom: .47rem;
      background: url("https://static.worldaic.com.cn/2024/web/static/images/huoban-bg-wap.jpg");
      background-size: 100% 102%;
      height: 7.42rem;

      .logo {
        width: 2.32rem;
        height: 1.16rem;
        cursor: pointer;
      }

      ul {
        display: flex;
        flex-wrap: wrap;

        li {
          flex: 0 0 33.3%;
          height: 1.16rem;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .swiper-btns {
        display: flex;
        justify-content: center;
        margin-top: .36rem;
      }

      .btn-img {
        width: .36rem;
        height: .36rem;
        margin: 0 .32rem;
      }
    }
  }
    
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/huoban.vue